import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from 'components/Footer';
import {
  ProjectContainer, ProjectBackground, ProjectHeader, ProjectSection,
  ProjectSectionContent, ProjectImage
} from 'components/ProjectLayout';
import { useScrollRestore } from 'hooks';
import { media } from 'utils/style';
import prerender from 'utils/prerender';
import resumeBackground from 'assets/resume-background.jpg';
import resumeBackgroundLarge from 'assets/resume-background-large.jpg';
import resumeBackgroundPlaceholder from 'assets/resume-background-placeholder.jpg';
import resume from 'assets/resume.png';
import resumeLarge from 'assets/resume.png';
import resumePlaceholder from 'assets/resume-placeholder.png';

const title = 'My Resume';
const description = 'Learn more about my background!';
const roles = [
  'High School Student',
  'Full Stack Developer',
  'Simulations Engineer',
];

function Resume() {
  useScrollRestore();

  return (
    <Fragment>
      <Helmet>
        <title>{`Resume | Vijay Shanmugam`}</title>
        <meta name="description" content={description} />
      </Helmet>
      <ProjectContainer>
        <ProjectBackground
          srcSet={`${resumeBackground} 1000w, ${resumeBackgroundLarge} 1920w`}
          placeholder={resumeBackgroundPlaceholder}
          entered={!prerender}
        />
        <ProjectHeader
          title={title}
          description={description}
          url="/resume.pdf"
          roles={roles}
          linkLabel="Download Resume"
        />
        <ProjectSection>
          <ProjectSectionContent>
            <ProjectImage
              reveal
              srcSet={`${resume} 800w, ${resumeLarge} 1440w`}
              placeholder={resumePlaceholder}
              sizes={`(max-width: ${media.mobile}px) 500px, (max-width: ${media.tablet}px) 800px, 1000px`}
              alt="Vijay Shanmugam's Resume."
            />
          </ProjectSectionContent>
        </ProjectSection>
      </ProjectContainer>
      <Footer />
    </Fragment>
  );
}

export default Resume;
